export default "__VITE_ASSET__CCuZbKdy__"